var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * If the parameter is both set, and is not null
 * @param toCheck
 * @returns {boolean}
 */
import axios from "axios";
import * as moment from 'moment';
import urls from "../../urls";
function isSet(toCheck) {
    return typeof toCheck !== 'undefined' && toCheck !== null;
}
class Session {
    //This insures that we are getting exactly what we expect (or an exception)
    constructor(message) {
        this.permanent_id = message.permanent_id;
        this.edar_id = message.edar;
        this.start = moment(message.start);
        this.amounts = message.amounts;
    }
    // Equivalent to python's __str__ built in function
    toString() {
        return this.permanent_id;
    }
}
class Deployment {
    constructor(message) {
        this.id = String(message.id);
        this.name = message.name;
        this.start_date = moment(message.start_date);
        this.sessions = [];
        for (let session of message.sessions) {
            this.sessions.push(new Session(session));
        }
    }
    // Take advantage of the fact all amounts are numbers to offer totals from all sessions
    get totals() {
        let totals = {};
        for (let session of this.sessions) {
            for (let key of Object.keys(session.amounts)) {
                if (!isSet(totals[key])) {
                    totals[key] = session.amounts[key];
                }
                else {
                    totals[key] += session.amounts[key];
                }
            }
        }
        return totals;
    }
    //Get all the days this covers
    //TODO: sort this in chronological order
    get days() {
        //Set handles removing duplicates, but not for moment objects
        //Clone is needed to prevent the original object from being overwritten
        let dates = new Set(this.sessions.map(session => session.start.clone().startOf('day').toISOString()));
        return Array.from(dates).map(date => moment(date));
    }
    //Get all the sessions for this that occurred on a particular day
    getSessionsForDay(date) {
        //Clone is needed to prevent the original object from being overwritten
        return this.sessions.filter(session => date.clone().startOf('day').isSame(session.start.clone().startOf('day')));
    }
    //Very similar to totals, but only for a particular date
    getTotalsForDay(date) {
        let totals = {};
        for (let session of this.getSessionsForDay(date)) {
            for (let key of Object.keys(session.amounts)) {
                if (!isSet(totals[key])) {
                    totals[key] = session.amounts[key];
                }
                else {
                    totals[key] += session.amounts[key];
                }
            }
        }
        return totals;
    }
    // Equivalent to python's __str__ built in function
    toString() {
        return this.name;
    }
}
export default {
    namespaced: true,
    state: {
        deployments: [],
    },
    mutations: {
        setDeployments(state, payload) {
            let newDeployments = [];
            for (let deployment of payload) {
                let newDeployment = null;
                try {
                    newDeployment = new Deployment(deployment);
                }
                catch (e) {
                    console.log(e);
                    continue;
                }
                newDeployments.push(newDeployment);
            }
            state.deployments = newDeployments;
        },
        clearDeployments(state, payload) {
            state.deployments = [];
        },
    },
    actions: {
        getDeployments(context) {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    let response = yield axios.get(urls.deployment);
                    context.commit('setDeployments', response.data);
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }));
        },
    },
    getters: {
        byId: state => id => {
            return state.deployments.find(deployment => {
                return String(deployment.id) === String(id);
            });
        }
    }
};
